import { render, staticRenderFns } from "./MoreJigActions.vue?vue&type=template&id=d15cba4c"
import script from "./MoreJigActions.vue?vue&type=script&lang=ts"
export * from "./MoreJigActions.vue?vue&type=script&lang=ts"
import style0 from "./MoreJigActions.vue?vue&type=style&index=0&id=d15cba4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports